import { Advice } from '../types'

interface Props {
  advice: Advice
  language: string
}

export function TagsCell(props: Props) {
  const { advice, language } = props
  return (
    <div className="flex flex-wrap">
      {advice.tags &&
        advice.tags.map((tag) => (
          <div key={advice.slug + tag.title} className="px-2 py-1 mr-2">
            <span
              key={advice.slug + tag.title}
              className="bg-gray-100 text-gray-800 text-nowrap  rounded-full px-2 py-1 text-xs mr-2"
            >
              {tag.title}
            </span>
          </div>
        ))}
    </div>
  )
}
